// Import Bootstrap JS
import 'bootstrap';

window.GetReCaptchaID = function(containerID) {
    var retval = -1;
    $(".g-recaptcha").each(function(index) {
      if(this.id == containerID)
      {
        retval = index;
        return;
      }
    });

    return retval;
}
  
function sideFormScrollWidth() {
  var sideShow = document.querySelectorAll(".side.show")[0];
  var sideWithDiff = sideShow.offsetWidth - sideShow.clientWidth;
  var sideShowRecaptcha = document.querySelectorAll(".side.show .g-recaptcha")[0];
  sideShowRecaptcha.style.marginRight = sideWithDiff+"px";
}

$(window).on('load', function(){
  let sideForm = $('main .side').first();
  let sideFormID = sideForm.attr('id');
  if(sideFormID != undefined) {
    let menuBtn = $('nav.navbar .contact-btn').first();
    menuBtn.attr('data-toggle', 'side');
    menuBtn.attr('data-target', '#'+sideFormID);
  }

  $("[data-toggle='side'][data-target]").click(function (e) {
  e.preventDefault();
  let side = $(this).data('target');
  if(!window.reCaptchaLoad) {
    var head = document.getElementsByTagName('head')[0];
    var script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = 'https://www.google.com/recaptcha/api.js';
    head.appendChild(script);
    window.reCaptchaLoad = true;
  }
  if($('body').hasClass('modal-open')) {
      if($('.side').hasClass('show')) {
          if($('.side.show').not(side)) {
                  $('.side.show').removeClass('show');
                  $(side).addClass('show');
                  sideFormScrollWidth();
              }
              else {
                  $('.side.show').removeClass('show');
                  $('body').removeClass('modal-open');
              }
          }
          else {
              $('body').removeClass('modal-open');
          }
      }
      else {
          $(side).addClass('show');
          sideFormScrollWidth();
          $('body').addClass('modal-open');
      }
  });

  $('.side').click(function() {
      let body = $('body');
      if($(this).hasClass('show')) {
          $(this).removeClass('show');
      }
      if($(body).hasClass('modal-open')) {
        $(body).removeClass('modal-open');
      }
  });

  $(".side .side-dialog").click(function(e) {
      e.stopPropagation();
  });

  $('.side .close').click(function() {
      let side = $(this).closest('.side');
      let body = $('body');
      if($(side).hasClass('show')) {
          $(side).removeClass('show');
      }
      if($(body).hasClass('modal-open')) {
          $(body).removeClass('modal-open');
      }
  });

  $('.side-frame .form-control').on('input',function(){
    var label = $(this).parent().find('label');
    if($(this).val() != '') {
        $(label).removeClass('label-hide');
    } else {
        $(label).addClass('label-hide');
    }
  });

  $("[data-toggle='collapse']").on('click', function() {
    $('.collapse.in').collapse('hide');
  });
});